import { getSnapshot, hasSnapshot, subscribe } from './source';
export var wait = function (source, maybePredicate) {
    // Don't wait for a predicate that already matches.
    if (maybePredicate &&
        hasSnapshot(source) &&
        maybePredicate(getSnapshot(source))) {
        return;
    }
    // By default, any snapshot other than the current value will do.
    var predicate = maybePredicate || (function () { return true; });
    // Get a promise that resolves once the source's snapshot matches the
    // condition.
    return new Promise(function (resolve, reject) {
        var unsubscribe = subscribe(source, function () {
            if (hasSnapshot(source)) {
                try {
                    if (predicate(getSnapshot(source))) {
                        unsubscribe();
                        resolve();
                    }
                }
                catch (error) {
                    reject(error);
                }
            }
        });
    });
};
